module.exports = __webpack_public_path__ + "static/media/万花筒绘圆装置.f956d2df.png";